<template>
    <div>
        <form class="divide-y divide-gray-200 lg:col-span-9" method="POST" v-on:submit.prevent="submit">
            <!-- Profile section -->
            <div class="pb-6 sm:pb-6 lg:pb-8">
                <div>
                    <p class="mt-1 text-sm text-gray-500">
                        Предоставление не достоверных данных приведет к блокировке.
                    </p>

                </div>

                <div class="mt-6 flex flex-col lg:flex-row">

                    <!--Form-->
                    <div class="flex-grow space-y-6">
                        <div>

                            <div class="flex space-x-16">
                                <label class="flex items-center">
                                    <t-radio name="options" value="I" v-model="data.user_type" @change="company=data.inn=null"/>
                                    <span class="ml-2 text ">Частное лицо</span>
                                </label>
                                <label class="flex items-center ml-2">
                                    <t-radio name="options" value="C" v-model="data.user_type"/>
                                    <span class="ml-2 text">Юридическое лицо</span>
                                </label>
                            </div>
                            <form-error :value="errors.user_type"/>


                            <transition enter-active-class="transition-all duration-1000 ease-out-quad"
                                        leave-active-class="transition-all duration-500 ease-in-quad"
                                        enter-class="opacity-0 scale-70"
                                        enter-to-class="opacity-100 scale-100"
                                        leave-class="opacity-100 scale-100"
                                        leave-to-class="opacity-0 scale-70">

                                <div v-if="data.user_type==='C'">
                                    <div class="mt-2 rounded-md shadow-sm flex">
                                        <span
                                            class="bg-gray-50 border border-r-0 border-gray-300 rounded-l-md px-3 inline-flex items-center text-gray-500 sm:text-sm">
                                          ИНН
                                        </span>
                                        <t-input name="name"
                                                 maxlength="12"
                                                 pattern="[0-9]+"
                                                 v-model="data.inn"
                                                 autocomplete="inn"
                                                 :variant="inn_status.variant"/>
                                        <form-error :value="errors.inn"/>

                                    </div>

                                    <div class="flex flex-wrap mt-2 w-100 space-x-1 sm:space-x-5" v-if="company">
                                        <p class="text-green-500"><b>{{ company.name.short_with_opf }}</b></p>
                                        <p>{{ company.management.name }}</p>
                                        <p><b>ОГРН:</b> {{ company.ogrn }}</p>
                                        <p><b>КПП:</b> {{ company.kpp }}</p>
                                    </div>

                                     <t-tag variant="error" v-if="inn_status.error">{{ inn_status.error }}</t-tag>

                                </div>

                            </transition>


                        </div>

                        <div >

                                <label for="region_id" class="block text-sm font-medium text-gray-700 required">
                                    Регион
                                </label>
                                <t-select id="region_id"
                                          placeholder="Выберите регион"
                                          :options="regions" v-model="data.region_id"></t-select>
                                <form-error :value="errors.region_id"/>

                            <div v-if="data.region_id">
                                <label for="city_id" class="block text-sm font-medium text-gray-700 required" >
                                    Город
                                </label>
                                <t-select id="city_id"
                                          placeholder="Выберите город"
                                          required
                                          :options="cities"
                                          v-model="data.city_id"></t-select>

                                <form-error :value="errors.city_id"/>

                                <div v-if="data.city_id">
                                    <label for="address" class="mt-1 form-label">Комментарий к местоположению</label>
                                    <t-input id="address" name="address" v-model = "data.address" />
                                </div>
                            </div>

                        </div>


                    </div>

                    <!--avatar-->
                    <div class="mt-6 flex-grow lg:mt-0 lg:ml-6 lg:flex-grow-0 lg:flex-shrink-0">
                        <p class="text-sm font-medium text-gray-700" aria-hidden="true">
                            Аватар \ Логотип
                        </p>
                        <!--Mobile-->
                        <div class="mt-1 lg:hidden">
                            <div class="flex items-center">
                                <div class="flex-shrink-0 inline-block rounded-full overflow-hidden h-12 w-12"
                                     aria-hidden="true">
                                    <img class="rounded-full h-full w-full" src="/images/empty_avatar.jpg" alt="">
                                </div>
                                <div class="ml-5 rounded-md shadow-sm">
                                    <div
                                        class="group relative border border-gray-300 rounded-md py-2 px-3 flex items-center justify-center hover:bg-gray-50 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-light-blue-500">
                                        <label for="user_photo"
                                               class="relative text-sm leading-4 font-medium text-gray-700 pointer-events-none">
                                            <span>Изменить</span>
                                            <span class="sr-only">аватар</span>
                                        </label>
                                        <input id="user_photo" name="user_photo" type="file"
                                               class="absolute w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Desktop -->
                        <div class="hidden relative rounded-full overflow-hidden lg:block">
                            <img class="relative rounded-full w-40 h-40" src="/images/empty_avatar.jpg" alt="">
                            <label for="user-photo"
                                   class="absolute inset-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center text-sm font-medium text-white opacity-0 hover:opacity-100 focus-within:opacity-100">
                                <span>Изменить</span>
                                <span class="sr-only"> аватар</span>
                                <input type="file" id="user-photo" name="user-photo"
                                       class="absolute inset-0 w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md">
                            </label>
                        </div>

                    </div>
                </div>


                <div class="mt-6 grid grid-cols-12 gap-6">

                    <div class="col-span-12 sm:col-span-3">

                        <label for="contact_name" class="block text-sm font-medium text-gray-700 ">Контактное имя <span class="text-red-500">*</span></label>
                        <t-input id="contact_name" v-model="data.contact_name" placeholder="Контактное имя"/>
                        <form-error :value="errors.contact_name"/>
                    </div>


                    <div class="col-span-12 sm:col-span-3">

                        <label for="phone1" class="block text-sm font-medium text-gray-700 ">Телефон 1 <span class="text-red-500">*</span></label>
                        <the-mask id="phone1" mask="+7 ###-###-####" type="tel" placeholder="Телефон" v-model="data.phone1"
                        class="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500"/>
                        <form-error :value="errors.phone1"/>
                    </div>

                    <div class="col-span-12 sm:col-span-3" v-if="data.phone1 && data.phone1.length>9">

                        <label for="phone2" class="block text-sm font-medium text-gray-700" >Телефон 2</label>
                        <the-mask id="phone2" mask="+7 ###-###-####" type="tel" placeholder="Телефон" v-model="data.phone2"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"/>

                    </div>

                    <div class="col-span-12 sm:col-span-3" v-if="data.phone2 && data.phone2.length>9">

                        <label for="phone3" class="block text-sm font-medium text-gray-700">Телефон 3</label>
                        <the-mask id="phone3" mask="+7 ###-###-####" type="tel" placeholder="Телефон" v-model="data.phone3"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"/>
                    </div>

                </div>

                <div class="mt-6 grid grid-cols-12 gap-6">

                    <div class="col-span-12 sm:col-span-6">
                        <label for="time_interval" class="form-label">Контактное время</label>
                        <input type='text' ref='slider-input' id="time_interval" name="time_interval"/>
                    </div>

                    <div class="col-span-12 sm:col-span-6 content-end">

                         <label for="contact_days" class="form-label"> Контактные дни </label>
                         <t-select id="contact_days" v-model="data.contact_days" placeholder="Выберите контактные дни" class="sm:mt-2"
                                   :options="[
                                                  'Понедельник - пятница',
                                                  'Понедельник - суббота',
                                                  'Любой день недели',
                                              ]" />

                    </div>


                </div>
                <div class="mt-2">
                    <label for="www" class="form-label">Сайт компании:</label>
                    <div class="mt-1">
                        <t-input id="www" v-model="data.www" />
                    </div>
                </div>


                <div class="mt-2">
                        <label for="about" class="block text-sm font-medium text-gray-700">
                            Информация о себе
                        </label>
                        <div class="mt-1">
                            <t-textarea id="about" rows="3" name="about" v-model="data.about"/>
                        </div>
                        <p class="mt-2 text-sm text-gray-500">
                            Краткая информация для вашего профиля. Ссылки не допустимы.
                        </p>
                </div>

            </div>


            <!-- Privacy section -->

            <div class="pt-6 divide-y divide-gray-200">

                                <div class="px-4 sm:px-6">
                                  <div>
                                    <h2 class="text-lg leading-6 font-medium text-gray-900">Сфера деятельности</h2>
                                    <p class="mt-1 text-sm text-gray-500">
                                      Можно выбрать несколько сфер деятельности. Некоторые сферы доступны только компаниям (необходимо указать ИНН)
                                    </p>
                                  </div>
                                  <ul class="mt-2 divide-y divide-gray-200">
                                    <li class="py-4 flex items-center justify-between" v-for="(scope, index ) in scopes">
                                      <div class="flex flex-col">
                                        <p id="privacy-option-label-1" class="text-sm font-medium text-gray-900">
                                            {{ scope.name }}
                                        </p>
                                        <p id="privacy-option-description-1" class="text-sm text-gray-500">
                                            {{ scope.descr }}
                                        </p>
                                      </div>
                                        <t-toggle v-model="selected_scopes[index+1]" v-on:input="scopeChange(index, $event)"/>

                                    </li>

                                  </ul>
                                </div>

                <div class="mt-4 py-4 px-4 flex justify-end sm:px-6">

                    <t-button type="submit">
                        Сохранить
                    </t-button>
                </div>
            </div>
        </form>
    </div>
</template>


<script>

import {TheMask} from 'vue-the-mask'
import axios from "axios"
import FormError from "../elements/FormError";
import $ from 'jquery'
import ionRangeSlider from 'ion-rangeslider'
export default {
    name: "UserProfile",
    components: {FormError, TheMask},
    props: {
        formData: {
            type: Object,
            required: true,
        },
        scopes: {
            type: Array,
            required: true,
        },
        userScopes: {
            type: Array,
            required: true,
        }
    },
    data: function () {
        return {
            'company': null,
            'inn_status': {variant:null, error:null},
            'errors': {},
            'data': this.formData,
            'regions': [],
            'cities': [],
            'selected_scopes': [],
        }
    },
    watch: {
      "data.inn": function (newInn, oldInn) {
          if(newInn && (newInn.toString().length === 10 || newInn.toString().length===12 )){
              // this.debouncedGetCompanyByInn(newInn);
              this.getCompanyByInn(newInn);

          } else {
              this.inn_status.variant =null;
              this.inn_status.error = null;
              this.company = null;
          }
      },
        "data.region_id": function() {
            this.getCities();
        }


    },
    created () {

        this.getRegions();
        this.getCities();

        if (this.data.inn){
            this.getCompanyByInn(this.data.inn);
        }

        this.userScopes.forEach(scope_index => {

            this.selected_scopes[scope_index]= true;

        })


        // this.debouncedGetCompanyByInn = _.debounce(this.getCompanyByInn, 500)
    },
    mounted() {
        const self = this
        let slider = $(this.$refs['slider-input']).ionRangeSlider(
            {
                 skin: "round",
                 type: "double",
                 min:0,
                 max: 24,
                 min_interval:4,
                 postfix: ":00",
                 onChange: function (data) {
                     self.data.contact_time_from = data.from;
                     self.data.contact_time_to = data.to;
                },
            }
            )

        slider.data("ionRangeSlider").update({
            from: this.data.contact_time_from,
            to: this.data.contact_time_to,
        });

    },
    methods: {
        getCompanyByInn: function() {

            //this.$swal('getByInn', 'this is a text', 'success');
            var vm =this;

            axios.get('/api/users/get-company-by-id/' + this.data.inn)
                .then (function(response){
                    if (response.data.length) {
                        vm.company = response.data[0].data;
                        vm.inn_status.variant = 'success';
                    } else {
                        vm.company = null;
                        vm.inn_status.variant = 'danger';
                        vm.inn_status.error = 'Организация не найдена. Такой ИНН не существует.';
                    }

                })
                .catch (function(error){
                    vm.company = null;
                    vm.inn_status.error = 'Ошибка обращения к серверу.';

                })


        },
        getRegions: function () {
            axios.get ('/api/location/regions').then (response =>{

                this.regions=[];
                response.data.forEach((item)=>{
                    this.regions.push ({'id': item.id, 'text': item.name})
                });
            });

        },
        getCities: function () {
            this.cities = {};
            if (this.data.region_id){
                axios.get('/api/location/cities/0/' + this.data.region_id).then(response=>{
                    this.cities =[];
                        response.data.forEach((item)=>{
                        this.cities.push ({'id': item.id, 'text': item.name})
                    });
                })
            }

        },
        submit: function () {

            if ( ! this.checkForm())
                return;

            let payload = {
                'profile': this.data,
                'scopes': this.selected_scopes,
            }

            axios.put('/api/users/'+this.data.id, payload).then (response => {
                window.location.href = '/admin'
            }).catch(errors=>{
                let normalized_errors = {};
                let e =errors.response.data.errors;
                //console.log();

                Object.keys(e).forEach((value) => {
                        normalized_errors[value.split('.').pop()] = e[value];
                    });
                this.errors = normalized_errors; // errors.response.data.errors;
            });
        },
        checkForm: function () {

                let errors = new Array(0);
                this.errors = {};
                let required_fields = ['region_id','city_id', 'phone1','contact_name'];

                // Check INN field
                if (this.data.user_type === 'C'){
                    if (this.company == null){
                        this.errors['inn'] = new Array(1);
                        this.errors['inn'][0] = "Введите ИНН соответствующий вашей компании";
                    }
                }

                // Check user scopes
                this.selected_scopes.forEach((value, index) => {
                    console.log(value,index);
                    if (value && this.scopes[index-1].extra && this.scopes[index-1].extra.inn) {
                         if (this.company == null) {
                            this.errors['user_type'] = new Array(1);
                            this.errors['user_type'][0] = "Выбранная сфера деятельности доступна только для компаний";
                        }
                    }
                })


                // Check required fields
                required_fields.forEach(field => {
                    if ( ! this.data[field]){
                        errors.push(field);
                    }
                });

                if (errors.length) {
                    errors.forEach(item => {
                        this.errors[item] = new Array(1);
                        this.errors[item][0] = "Поле обязательно для заполнения";
                    });
                }


                if ( ! _.isEmpty(this.errors)){
                    this.$swal ('Ошибки', 'Исправьте ошибки и повторите попытку', 'error');
                    return false;
                }

                return true;

        },
        scopeChange: function (index, event) {

            if (this.scopes[index].extra && this.scopes[index].extra.inn){

                if (event && this.company == null) {
                    this.$swal('Внимание', 'Сфера деятельности доступна только для компаний. Необходимо указать инн', 'error');
                    //this.selected_scopes[index] = false ;
                }

            }

        }
    }
}
</script>

<style lang="sass">
@import "../../../../node_modules/ion-rangeslider/css/ion.rangeSlider.min.css"

</style>
